export const mapStatus = {
  new: 0,
  saved: 1,
  published: 2,
  modified: 3,
};
